import { ListenerEvent as PackageListenerEvent } from '@carvana/merch-native';

enum SearchListenerEvent {
  SaveSearch = 'save_search'
}

export const ListenerEvent = {
  ...SearchListenerEvent,
  ...PackageListenerEvent
};

export type ListenerEventType = SearchListenerEvent | PackageListenerEvent;
